// Suchfeld (snippets/kik-search-field.liquid): Impact öffnet die Such-Schublade über aria-controls auf document.body.
// Dieser Listener hängt an document und läuft danach. Er setzt den Fokus noch im Klick ins Eingabefeld,
// sonst zeigt iOS keine Tastatur.

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-kik-search-open]')) {
    return;
  }

  const drawer = document.getElementById('search-drawer');
  const input = drawer && drawer.querySelector('input[name="q"]');

  if (drawer && drawer.hasAttribute('open') && input) {
    input.focus({ preventScroll: true });
  }
});
